interface FolderClipProps {
  className?: string;
  width?: number;
  height?: number;
}

export default function FolderClip({
  className,
  width = 77,
  height = 106,
}: FolderClipProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 77 106.26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 3C0 1.34315 1.34315 0 3 0H74C75.6569 0 77 1.34315 77 3V30.8H0V3Z"
        fill="var(--color-marketing-border)"
      />
      <path
        d="M9.24023 30.7998V67.7598C9.24023 83.9195 22.3403 97.0204 38.5 97.0205C54.6599 97.0205 67.7598 83.9196 67.7598 67.7598V30.7998H77V69.2598C77 89.6943 60.4345 106.26 40 106.26H37C16.5655 106.26 0 89.6943 0 69.2598V30.7998H9.24023Z"
        fill="var(--color-marketing-border)"
      />
      <path
        d="M9.24 19.94C9.24 18.2832 10.5831 16.94 12.24 16.94H15.48C17.1369 16.94 18.48 18.2832 18.48 19.94V30.8H9.24V19.94Z"
        fill="var(--color-marketing-blue)"
      />
      <path
        d="M58.52 19.94C58.52 18.2832 59.8631 16.94 61.52 16.94H64.76C66.4169 16.94 67.76 18.2832 67.76 19.94V30.8H58.52V19.94Z"
        fill="var(--color-marketing-blue)"
      />
    </svg>
  );
}
